import { Checkbox, CheckboxProps } from "@chakra-ui/react";
import React from "react";

interface Props extends CheckboxProps {}

export const UiCheckbox = React.forwardRef<"input", CheckboxProps>(
  ({ ...rest }: Props, ref: React.ForwardedRef<any>) => (
    <Checkbox
      ref={ref}
      _focus={{ boxShadow: "none", outline: "none", shadow: "none" }}
      _checked={{
        "& .chakra-checkbox__control": { background: "blue", borderColor: "blue" },
        "& .chakra-checkbox__control:hover": { background: "blue", borderColor: "blue" },
        "& .chakra-checkbox__control:checked": { background: "blue", borderColor: "blue" },
      }}
      sx={{
        "& .chakra-checkbox__control": { borderRadius: "0.25rem" },
      }}
      borderColor="neutral.gray200"
      size="lg"
      iconColor="blue.400"
      // _checked={{ backgroundColor: "blue" }}
      css={`
        > span:first-of-type {
          box-shadow: unset;
        }
      `}
      {...rest}
    />
  )
);
